<ng-container *transloco="let t">
<ion-menu contentId="root-content" (ionWillOpen)="onMenuWillOpen()">
    <ion-header class="ion-padding">
        <ion-toolbar>
            <ion-title>
	            <button
		            type="button"
		            class="menu-logo-btn d-flex m-auto"
		            (click)="rootHome()"
		            [attr.aria-label]="t('menu.title')">
	                <img [ngSrc]="'assets/icons/LOGO_SLAVEOUS.png'" alt="Slaveous logo" height="50" width="50"/>
	            </button>
	            @if (currentProfile()) {
		            <ion-header
			            class="ion-padding-top text-center">{{t("menu.title")}} {{ currentProfile()!.username }}</ion-header>
		            @if (profileCompletion().percentage !== 100) {
			            <div class="profile-completion" [style.color]="profileCompletion().color">
				            {{ t("profile_completion.label") }}: {{ profileCompletion().percentage }}%
			            </div>
		            }
	            }
            </ion-title>
        </ion-toolbar>
    </ion-header>

    <ion-content class="ion-padding">
        <ion-list lines="none">
	        @for (p of appPages(); track p.id) {
		        @if (!p.pages) {
			        <ion-menu-toggle>
				        @if (p.active) {
					        <ion-item [routerLink]="translateService.localize(p.url)" [detail]="false" routerLinkActive="selected" [button]="true">
			                    <ion-icon [name]="p.icon" slot="start"></ion-icon>
			                    <ion-label>{{t('menu.label.' + p.title)}} {{ p.prop }}</ion-label>
						        @switch (true) {
							        @case (p.id === 4 && contactNotification() > 0) {
								        <ion-badge slot="end">{{ contactNotification() }}</ion-badge>
							        }
							        @case (p.id === 2 && messageNotification() > 0) {
								        <ion-badge slot="end">{{ messageNotification() }}</ion-badge>
							        }
							        @case (p.id === 3 && privateMessageNotification() > 0) {
								        <ion-badge slot="end">{{ privateMessageNotification() }}</ion-badge>
							        }
						        }
					        </ion-item>
				        }
	            </ion-menu-toggle>
		        } @else {
			        <ion-item [button]="true" [detail]="true" (click)="p.open = !p.open">
				        <ion-icon [name]="p.icon" slot="start"></ion-icon>
				        <ion-label>{{t('menu.label.' + p.title)}} {{ p.prop }}</ion-label>
			        </ion-item>
			        @if (p.open) {
				        <ion-list>
					        @for (subPage of p.pages; track subPage.id) {
						        <ion-menu-toggle>
							        @if (subPage.active) {
								        <ion-item [routerLink]="translateService.localize(subPage.url)" [detail]="false" routerLinkActive="selected" [button]="true">
						                    <ion-icon [name]="subPage.icon" slot="start"></ion-icon>
						                    <ion-label>{{t('menu.label.' + subPage.title)}} {{ subPage.prop }}</ion-label>
								        </ion-item>
							        }
						        </ion-menu-toggle>
					        }
				        </ion-list>
			        }
		        }
	        }
	        @if (profileService.isAuthenticated) {
		        <ion-menu-toggle>
	                <ion-item (click)="logout()" [button]="true" [detail]="false">
	                    <ion-icon slot="start" name="log-out"></ion-icon>
	                    <ion-label> {{t("menu.label.logout")}} </ion-label>
	                </ion-item>
                </ion-menu-toggle>
	        }

        </ion-list>
    </ion-content>
	<app-footer></app-footer>
</ion-menu>

</ng-container>
